import Tooltip from "@/components/atoms/Tooltip/Tooltip";
import { trackMetaRatingLearnMore } from "@/events/metaRatingMixpanel";
import { useTranslation } from "@repo/shared/i18n";
import { ReactElement } from "react";
import { NavLink } from "react-router";

/* One sentence and a way out: the tiers and the calculation are the landing
   page's job, and a card carries a lot of these. */
const Explanation = () => {
  const { t } = useTranslation("common");
  return (
    <p className="w-60 text-sm text-white">
      {t("metaRatingExplanation")}{" "}
      {/* The portal sits outside the card in the DOM but inside it in the React
          tree, which is what events bubble through: without stopPropagation the
          card's own onClick runs too and logs a view_content it never had. */}
      <NavLink
        to="/meta-rating"
        // New tab: a side trip from a tooltip shouldn't pull you off the page
        target="_blank"
        rel="noreferrer"
        className="font-semibold underline"
        onClick={(e) => {
          e.stopPropagation();
          trackMetaRatingLearnMore();
        }}
      >
        {t("learnMore")}
      </NavLink>
    </p>
  );
};

/**
 * Explains a meta rating badge on hover. Wraps the badge itself rather than
 * adding an info icon, so nothing new appears on cards that already carry one.
 * The child must be a native element: `asChild` puts the trigger on it.
 */
export const MetaRatingExplainer = ({
  children,
}: {
  children: ReactElement;
}) => (
  <Tooltip
    asChild
    content={<Explanation />}
    /* Slower than the tags elsewhere: a grid of cards is mostly badge, so a
       quick delay fires them off just from crossing the page. */
    delayDuration={700}
    className="z-[120]"
  >
    {children}
  </Tooltip>
);
